const CDN_ORIGIN = 'https://cdn.magicpatterns.com'
const FONTS_ORIGIN = 'https://fonts.gstatic.com'

function addLink(rel: string, href: string, attrs: Record<string, string> = {}) {
  if (typeof document === 'undefined') return
  const existing = document.head.querySelector(
    `link[rel="${rel}"][href="${href}"]`,
  )
  if (existing) return

  const link = document.createElement('link')
  link.rel = rel
  link.href = href
  Object.entries(attrs).forEach(([key, value]) => link.setAttribute(key, value))
  document.head.appendChild(link)
}

/**
 * Warms up the origins the landing page depends on so the first paint
 * (and the checkout jump) start without extra DNS/TLS round-trips.
 */
export function warmConnections(checkoutUrl: string, heroImage: string) {
  addLink('preconnect', CDN_ORIGIN, { crossorigin: '' })
  addLink('preconnect', FONTS_ORIGIN, { crossorigin: '' })
  addLink('preload', heroImage, { as: 'image', fetchpriority: 'high' })

  try {
    const checkoutOrigin = new URL(checkoutUrl).origin
    addLink('dns-prefetch', checkoutOrigin)
    addLink('preconnect', checkoutOrigin)
  } catch {
    // Ignore malformed URLs — the CTA still navigates normally.
  }
}

/**
 * Runs non-critical work (analytics, third-party scripts) once the browser
 * is idle so it never competes with the first render.
 */
export function runWhenIdle(task: () => void) {
  if (typeof window === 'undefined') return

  const idle = (window as Window & {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
  }).requestIdleCallback

  if (idle) {
    idle(task, { timeout: 2500 })
  } else {
    setTimeout(task, 1200)
  }
}
